import React from "react";
import lodash from "lodash";
import * as helpers from "../helpers";

const createComponent = (Component) => {
	class BrandLibComponent extends React.Component {
		constructor(props, context) {
			super(props, context);
			this.state = {
				isMobile: null
			};

			this.updateDimensions = this.updateDimensions.bind(this);
		}

		updateDimensions() {
			this.setState(
				lodash.assign({}, this.state, {
					isMobile: helpers.isMobile()
				})
			);
		}

		componentDidMount() {
			this.updateDimensions();
			window.addEventListener("resize", this.updateDimensions);
		}

		componentWillUnmount() {
			window.removeEventListener("resize", this.updateDimensions);
		}

		render() {
			const { isMobile } = this.state;
			return <Component isMobile={isMobile} {...this.props} />;
		}
	}
	return BrandLibComponent;
};

export default createComponent;
